import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

// Ensure DD-MM-YYYY strict parsing works across the Channel folder
dayjs.extend(customParseFormat);

/**
 * Keys in your raw data are usually "DD-MM-YYYY".
 * Some APIs may return "YYYY-MM-DD".
 */
export function parseDataKey(key) {
  if (!key) return null;
  const d = dayjs(key, ["DD-MM-YYYY", "YYYY-MM-DD"], true);
  return d.isValid() ? d : null;
}

export function parseInputDate(input) {
  if (!input) return null;
  const d = dayjs(input, "YYYY-MM-DD", true);
  return d.isValid() ? d : null;
}
